import React from 'react';
import { TabbedOverviewPage, WhatItMeasuresSection } from '../components/OverviewSections.comp';

// Common Section text with its own fallback copy — shown even before the
// partner has any dashboard data, like the other Introduction pages.
const AboutAssessmentPage = () => (
    <TabbedOverviewPage
        skipNoDataGate
        tabs={[
            {
                label: 'What Does the Child Online Safety (COS) Children Assessment Measure?',
                content: <WhatItMeasuresSection/>,
            },
        ]}
    />
);

export default AboutAssessmentPage;
